import React from 'react';

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  hint?: string;
  error?: string;
  options?: SelectOption[];
  required?: boolean;
}

export function Select({
  label,
  hint,
  error,
  options = [],
  required,
  className = '',
  id,
  children,
  ...props
}: SelectProps) {
  const selectId = id || `select-${Math.random().toString(36).substring(7)}`;

  return (
    <div className="form-group">
      {label && (
        <label htmlFor={selectId}>
          {label}
          {required && <span style={{ color: 'var(--danger)' }}> *</span>}
        </label>
      )}
      <select
        id={selectId}
        className={`form-control ${error ? 'error' : ''} ${className}`}
        {...props}
      >
        {children ||
          options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
      </select>
      {hint && !error && <small className="form-help">{hint}</small>}
      {error && <small className="form-error">{error}</small>}
    </div>
  );
}
